<div class="dialog">
  @if (isMobileView) {
    <header class="mobile-app-bar sticky-header">
      <p (click)="close()" class="task-header-action" translate>Cancel</p>
      <h2 class="mobile-app-bar__heading">{{ 'Room' | translate }} {{ (currentRoom ? 'Edit' : 'Add') | translate | lowercase }}</h2>
      <p (click)="save()" [class.disabled]="form.invalid || isLoading" class="task-header-action" translate>Save</p>
    </header>
  }

  @if (!isMobileView) {
    <header class="dialog__header">
      <h3 class="dialog__header__title">{{ 'Room' | translate }} {{ (currentRoom ? 'Edit' : 'Add') | translate | lowercase }}</h3>
      <div class="dialog__header__action-buttons">
        <div (click)="close()" class="dialog__header__action-buttons__button">
          <span>
            <app-icon [cssStyle]="{ 'margin-top': '3px' }" iconName="close" size="14px"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }

  <div class="dialog__content">
    <form [formGroup]="form" action="" class="form">
      <!-- Image Selector -->
      <div class="input-group">
        <label for="image" translate>Image</label>
        <app-image-selector
          (imageSelected)="selectedImage = $event"
          [aspectRatio]="4 / 3"
          [entityId]="roomId"
          [fullWidthPreview]="true"
          [imageCropper]="true"
          [isUpdateMode]="isUpdateMode"
          [sectionType]="SectionType.ROOM"
          formControlName="image"
          id="image"
          name="image"
        ></app-image-selector>
        <!--        <app-form-error [control]="form.get('image')" [name]="'Image' | translate"></app-form-error>-->
      </div>

      <!-- Type -->
      <div class="input-group --required">
        <label for="type" translate>Type</label>
        <app-dropdown [options]="roomTypes" bindValue="value" displayName="key" formControlName="type" id="type" name="type"></app-dropdown>
        <app-form-error [control]="form.get('type')" [name]="'Type' | translate"></app-form-error>
      </div>

      <!-- Name -->
      <div class="input-group w-100 --required">
        <label for="name" translate>Name</label>
        <input [placeholder]="'Enter Name' | translate" class="full-width-input" formControlName="name" id="name" name="name" type="text" />
        <app-form-error [control]="form.get('name')" [name]="'Name' | translate"></app-form-error>
      </div>

      <!-- Email -->
      <div class="input-group">
        <label for="email" translate>E-Mail</label>
        <input [placeholder]="'Enter Email' | translate" class="full-width-input" formControlName="email" id="email" name="email" type="email" />
      </div>

      <!-- Phone No -->
      <div class="input-group">
        <label for="phoneNo" translate>Phone No</label>
        <input [placeholder]="'Enter Phone No' | translate" appNumberInput class="full-width-input" formControlName="phoneNo" id="phoneNo" name="phoneNo" type="tel" />
      </div>

      <!-- Address -->
      <div class="input-group">
        <label for="address" translate>Address</label>
        <input [placeholder]="'Enter Address' | translate" class="full-width-input" formControlName="address" id="address" name="address" type="text" />
      </div>

      <!-- Description -->
      <div class="input-group --required">
        <label for="description" translate>Description</label>
        <textarea [placeholder]="'Enter Description' | translate" class="full-width-input" formControlName="description" id="description" name="description" rows="3"></textarea>
        <app-form-error [control]="form.get('description')" [name]="'Description' | translate"></app-form-error>
      </div>

      <!-- No Of Persons -->
      <div class="input-group --required">
        <label for="noOfPersons" translate>No Of Persons</label>
        <input
          [maxLength]="4"
          [placeholder]="'Enter No Of Persons' | translate"
          appNumberInput
          class="full-width-input"
          formControlName="noOfPersons"
          id="noOfPersons"
          name="noOfPersons"
          type="number"
        />
        <app-form-error [control]="form.get('noOfPersons')" [name]="'No Of Persons' | translate"></app-form-error>
      </div>

      <!-- Price -->
      <div class="input-group">
        <label for="price" translate>Price</label>
        <input [maxLength]="4" [placeholder]="'Enter Price' | translate" appNumberInput class="full-width-input" formControlName="price" id="price" name="price" type="number" />
        <!--        <app-form-error [control]="form.get('price')" [name]="'Price' | translate"></app-form-error>-->
      </div>

      <!-- Weekdays -->
      <ng-container formArrayName="weekdays">
        <div class="input-group">
          <label translate>Availability</label>
          <div class="input-groups-wrapper">
            @for (weekday of weekdaysFormArray.controls; track weekday; let i = $index) {
              <ng-container [formGroupName]="i">
                <div class="input-group --required">
                  <label for="day-{{ i }}" translate>Day</label>
                  <app-dropdown [dropdownPosition]="'top'" [id]="'day-' + i" [options]="days" bindValue="number" displayName="name" formControlName="day"></app-dropdown>
                  <app-form-error [control]="weekdaysFormArray.controls[i].get('day')" [name]="'Day' | translate"></app-form-error>
                </div>
                <div class="flex-row-between-center gap-10">
                  <div class="input-group --required">
                    <label for="time_from-{{ i }}" translate>Time From</label>
                    <app-time-picker-input [id]="'time_from-' + i" [name]="'time_from-' + i" class="full-width-input" formControlName="time_from"></app-time-picker-input>
                    <app-form-error [control]="weekdaysFormArray.controls[i].get('time_from')" [name]="'Time From' | translate"></app-form-error>
                  </div>
                  <div class="input-group --required">
                    <label for="time_to-{{ i }}" translate>Time To</label>
                    <app-time-picker-input
                      [id]="'time_to-' + i"
                      [name]="'time_to-' + i"
                      [previousSelectedTime]="weekdaysFormArray.controls[i].get('time_from').value"
                      class="full-width-input"
                      formControlName="time_to"
                    ></app-time-picker-input>
                    <app-form-error [control]="weekdaysFormArray.controls[i].get('time_to')" [name]="'Time To' | translate"></app-form-error>
                  </div>
                </div>
              </ng-container>
              <div class="flex-row-end-center gap-6 mt-12">
                @if (i === weekdaysFormArray.controls.length - 1) {
                  <button (click)="addWeekdaysRow()" [tippy]="'Add' | translate" class="button button-simple button-icon-only">
                    <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="add" size="20px"></app-icon>
                  </button>
                }
                @if (weekdaysFormArray.controls.length > 1) {
                  <button (click)="removeWeekdaysRow(i)" [tippy]="'Remove' | translate" class="button button-simple button-icon-only">
                    <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="trash-bin" size="20px"></app-icon>
                  </button>
                }
              </div>
            }
          </div>
        </div>
      </ng-container>

      <!-- Tags -->
      <div class="input-group">
        <label for="tags" translate>Tags</label>
        <ng-select
          [addTag]="addTagFn"
          [closeOnSelect]="true"
          [items]="roomsTags"
          [multiple]="true"
          [notFoundText]="'No tags available' | translate"
          [placeholder]="'Select Tags' | translate"
          [searchable]="true"
          addTag="true"
          bindLabel="label"
          bindValue="value"
          class="custom"
          formControlName="tags"
          id="tags"
          name="tags"
        ></ng-select>
      </div>
    </form>
  </div>

  <footer>
    <div class="dialog__footer">
      @if (!isMobileView) {
        <div class="dialog__footer__buttons">
          <app-button (click)="close()" [idleText]="'Cancel' | translate" [inlineStyle]="{ border: '1px solid var(--gray)' }" cssClass="button-simple"></app-button>
          <app-button (clickEvent)="save($event)" [disabled]="form.pristine || isLoading" [idleText]="(currentRoom ? 'Update' : 'Save') | translate"></app-button>
        </div>
      }
    </div>
    @if (isMobileView) {
      <div class="mobile-button mx-16 mb-34">
        <app-button
          (clickEvent)="save($event)"
          [disabled]="form.pristine || isLoading"
          [idleText]="(currentRoom ? 'Update' : 'Save') | translate"
          [isLoading]="isLoading"
          cssClass="button-primary button-full"
        ></app-button>
      </div>
    }
  </footer>
</div>
